import axios from 'axios';
import { Filter } from './Filter';
import { GetToken } from './Session';

export function GetAddresses(q) {
  return axios.get('/api/v1/addresses' + Filter(q), {
    headers: { Authorization: 'Bearer ' + GetToken().access_token },
  });
}

export function GetAddress(id) {
  return axios.get(`/api/v1/addresses/${id}`, { headers: { Authorization: 'Bearer ' + GetToken().access_token } });
}

export function GetdeliveryServices(q) {
  return axios.get('/api/v1/delivery_services' + Filter(q), {
    headers: { Authorization: 'Bearer ' + GetToken().access_token },
  });
}

export function GetProvinces(q) {
  return axios.get('/api/v1/provinces' + Filter(q), {
    headers: { Authorization: 'Bearer ' + GetToken().access_token },
  });
}

export function GetCities(q) {
  return axios.get('/api/v1/cities' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token } });
}

export function GetSubdistrict(q) {
  return axios.get('/api/v1/subdistricts' + Filter(q), {
    headers: { Authorization: 'Bearer ' + GetToken().access_token },
  });
}

export function PostAddress(data) {
  return axios.post('/api/v1/addresses', data, { headers: { Authorization: 'Bearer ' + GetToken().access_token } });
}

export function PutAddress(id, data) {
  return axios.put('/api/v1/addresses/' + id, data, {
    headers: { Authorization: 'Bearer ' + GetToken().access_token },
  });
}

export function DeleteAddress(id) {
  return axios.delete(`/api/v1/addresses/${id}`, {
    headers: { Authorization: 'Bearer ' + GetToken().access_token },
  });
}

export function GetAddressLine2(address) {
  const lines = [
    address.urban_village?.name ?? '',
    address.subdistrict?.name ?? '',
    address.city?.name ?? '',
    address.province?.name ?? '',
  ].filter(Boolean);

  return `${lines.join(', ')} ${address.postal_code ?? ''}`;
}
